import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/exemption';

const initialState = fromJS({
  data: [],
  state: null,
  stateCreate: null,
  stateUpdate: null,
  stateDelete: null,
  mappings: [],
  stateMappings: null,
  applyto: [],
  stateApplyto: null,
  types: [],
  stateTypes: null,
  orders: { data: [], state: null },
  missingExemptions: [],
});

const ExemptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.EXEMPTIONS_FETCH_START: {
      return state.set('state', fetchingState.FETCHING);
    }
    case actions.EXEMPTIONS_FETCH_ERROR: {
      return state.set('state', fetchingState.ERROR);
    }
    case actions.EXEMPTIONS_FETCH_SUCCESS: {
      return state
        .set('state', fetchingState.LOADED)
        .set('data', fromJS(_.get(action, 'data.results', [])));
    }
    case actions.EXEMPTION_MAPPINGS_FETCH_START: {
      return state.set('stateMappings', fetchingState.FETCHING);
    }
    case actions.EXEMPTION_MAPPINGS_FETCH_ERROR: {
      return state.set('stateMappings', fetchingState.ERROR);
    }
    case actions.EXEMPTION_MAPPINGS_FETCH_SUCCESS: {
      return state
        .set('stateMappings', fetchingState.LOADED)
        .set('mappings', fromJS(_.get(action, 'data.results', [])));
    }
    case actions.EXEMPTION_APPLYTO_FETCH_START: {
      return state.set('stateApplyto', fetchingState.FETCHING);
    }
    case actions.EXEMPTION_APPLYTO_FETCH_ERROR: {
      return state.set('stateApplyto', fetchingState.ERROR);
    }
    case actions.EXEMPTION_APPLYTO_FETCH_SUCCESS: {
      return state
        .set('stateApplyto', fetchingState.LOADED)
        .set('applyto', fromJS(_.get(action, 'data.results', [])));
    }
    case actions.CREATE_EXEMPTION_START: {
      return state.set('stateCreate', fetchingState.FETCHING);
    }
    case actions.UPDATE_EXEMPTION_START: {
      return state.set('stateUpdate', fetchingState.FETCHING);
    }
    case actions.DELETE_EXEMPTION_START: {
      return state.set('stateDelete', fetchingState.FETCHING);
    }
    case actions.CREATE_EXEMPTION_SUCCESS: {
      return state.set('stateCreate', fetchingState.LOADED);
    }
    case actions.UPDATE_EXEMPTION_SUCCESS: {
      return state.set('stateUpdate', fetchingState.LOADED);
    }
    case actions.DELETE_EXEMPTION_SUCCESS: {
      const { exemptionCode } = action.payload;
      return state.set('stateDelete', fetchingState.LOADED).set(
        'data',
        fromJS(
          state
            .get('data')
            .toJS()
            .filter(codefile => codefile.exemptionCode !== exemptionCode),
        ),
      );
    }
    case actions.CREATE_EXEMPTION_ERROR: {
      return state.set('stateCreate', fetchingState.ERROR);
    }
    case actions.UPDATE_EXEMPTION_ERROR: {
      return state.set('stateUpdate', fetchingState.ERROR);
    }
    case actions.DELETE_EXEMPTION_ERROR: {
      return state.set('stateDelete', fetchingState.ERROR);
    }

    case actions.EXEMPTION_TYPES_FETCH_START: {
      return state.set('stateTypes', fetchingState.FETCHING);
    }
    case actions.EXEMPTION_TYPES_FETCH_ERROR: {
      return state.set('stateTypes', fetchingState.ERROR);
    }
    case actions.EXEMPTION_TYPES_FETCH_SUCCESS: {
      return state
        .set('stateTypes', fetchingState.LOADED)
        .set('types', fromJS(_.get(action, 'data.results', [])));
    }

    case actions.EXEMPTION_ORDERS_FETCH_START: {
      return state.setIn(['orders', 'state'], fetchingState.FETCHING);
    }
    case actions.EXEMPTION_ORDERS_FETCH_ERROR: {
      return state.setIn(['orders', 'state'], fetchingState.ERROR);
    }
    case actions.EXEMPTION_ORDERS_FETCH_SUCCESS: {
      return state
        .setIn(['orders', 'state'], fetchingState.LOADED)
        .setIn(['orders', 'data'], fromJS(_.get(action, 'data.results', [])))
        .set(
          'missingExemptions',
          fromJS(_.get(action, 'data.missingExemptions', [])),
        );
    }

    default: {
      return state;
    }
  }
};

export default ExemptionReducer;
